import type { IconSvgObject } from './types';

const Cabinet04Icon: IconSvgObject = [
  ["path", { d: "M5 18L4 22M19 18L20 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 18V8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 11.5H9M7 14.5H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["rect", { x: "2", y: "8", width: "20", height: "10", rx: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["rect", { x: "5", y: "2", width: "6", height: "6", rx: "1.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Cabinet04Icon;
